import React from 'react';
import NewDeposit from 'components/Tvendo/Bank/DataMaster/Deposits/NewDeposit';
// import { useParams } from 'react-router-dom';

function NewDepositView() {
  // const { id } = useParams();
  return <NewDeposit />;
}

export default NewDepositView;
